/* eslint-disable compat/compat */
/**
 * @fileOverview Callback form submission.
 * @author Theo Suja <theo.suja@selectra.info>
 */

// Dependencies
import formatPhone from '../helpers/format-E164';
import formatDate8601 from '../helpers/format-date-ISO8601-zoho';
import manageMessage from '../helpers/manage-form-field-message';
import callBackRequestType from './callback-request-type.js';


export default function submitCallbackForm(submitOptions, submitButton) {
  let data = {};
  const country = document.querySelector('meta[property="og:country_name"]').content;
  // Callcenter status can be close (backend) or closed (frontend dialga API).
  const closedStatus = ['close', 'closed'];
  data.callcenter_open = !closedStatus.includes(submitOptions.status);

  if (data.callcenter_open === false && submitOptions.name) {
    data.client_name = submitOptions.name;
  }

  if (submitOptions.day && submitOptions.hour) {
    let date = new Date(`${submitOptions.day}T${submitOptions.hour}`);
    data.call_back_at = formatDate8601(date);
  }

  data.token = submitOptions.token;
  data.timestamp = submitOptions.timestamp;
  data.phone = formatPhone(submitOptions.phone, submitOptions.country);
  data.modal_url = submitOptions.modalURL;
  data.url_origin = location.origin + location.pathname;

  if (submitOptions.email) {
    data.email = submitOptions.email;
  }

  // Look for dynamic middleware fetch URL.
  let middleware = submitButton.getAttribute('data-middleware');
  if (!middleware) {
    middleware = '/agrippa-modal/middleware';
  }

  fetch(middleware, {
    method: 'POST',
    mode: 'same-origin',
    body: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    }
  }).then(response => {
    return response.json();
  }).then(json => {
    if (json) {
      if (json.status === 200) {
        manageMessage(submitButton, json.message, 'success');
        console.log(json)
        submitButton.disabled = true;

        let
          modalUrl = submitOptions.modalURL,
          requestType = (submitOptions.status === 'open') ? '1' : '0';
        callBackRequestType(requestType, modalUrl);

        return;
      } else {
        manageMessage(submitButton, json.message, 'danger');
        console.error('Callback API: ', json.message)
      }
    }
  }).catch(console.error);
}
